import React from 'react';

import './style.css'
import './carousel.css'
import './custom.css'
import './asserts/fonts/awesome/css/all.css'

import Outer from './componentes/header/outer'
import MainContainer from './componentes/body/main-container'
import Footer from './componentes/footer/footer'
import AiAssistantTray from './componentes/ai/AiAssistantTray'
import PWAPrompt from 'react-ios-pwa-prompt'

document.body.className = "home"

function App() {
    return (
        <>
            <div className="App generalContainer">
                <div className="generalContent">
                    <Outer />
                    <MainContainer />
                    <Footer />
                    <AiAssistantTray />
                </div>
            </div>
            <PWAPrompt
                copyTitle={"Instalar App?"}
                copyShareButtonLabel={"Pulsa el botón 'Compartir' de tu navegador"}
                copyAddHomeButtonLabel={"Pulsa en 'Agregar a Inicio'"}
                promptOnVisit={1} timesToShow={3} copyClosePrompt="Cerrar" copyBody="En iOS no se instala con un botón. Sigue estas 2 instrucciones en Safari:" permanentlyHideOnDismiss={false} />
        </>
    );
}

export default App;
